var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F2F1F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_809",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_809",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAflBMVEVHcExnZ2dxcXGJiYl0dHSFhYV9fX1kZGR/f394eHhpaWlra2tsbGxra2thYWF6enqFhYWHh4dra2uJiYl/f3+JiYl0dHS7u7u0tLSqqqqurq5qamqIiIhvb2+WlpaDg4OOjo58fHxfX193d3eampqmpqa4uLiSkpKdnZ2ioqJZAn6FAAAAFnRSTlMAqtXULgdB/hAb4fTDkMlUwKdte+XsQD7iMgAABO9JREFUWMPdV2l7qkoMLsqqUEQtsgzDjMP6///gfZOhWpe2x/PtnuDT8pDkzR6Gt7d/m7wwAoXe3yn7hyzbrUG7XXZwXwfwP5QaF1Jq7b8McFCyI5rojxSHP9e0IYeZuqiDVGafhr+HftjtUgiHawDMZQUqZwCsoeqlu/XhF4goE0p9QCr6AEB5YioIIHoLDx9CiezHfLo7oeQoIIUcSll9Akj14bvAllKJn/Lpr0mGpdZilF1hAYYJoOsrz/9FvyMpNcqvAHgCRPkzgk9WZVeWJIa7cRoswKmXC80V0MdvEKJdi87pEHc1oXlk1y8OwIW+k/SoHE4FeKrdPclkmH3qI2uznMqLOkOUk5wsjxGyx2oeWgEbS96HYjjd0eVR0Y2jaB860+MAyludakb6prm6ceZUcRD3LoQAUGoeTpermIQ2Ochogchg3zJOJYbrEQAhAOHqQjG1rG3J6K64OgD9Y/o4BBkjVNZOpaxxvphEuTjWKYUUeM/KqDEHki1VrdVqmCxKy94NM/R19nSk/GMLhGoYWB8qTb3dxPFqWzeMBoRhKCQFED3ZfqGbAkDIAkKKrdebxKed6CcbCyHAGzohkAH3dlN6Kbbf8ajhQY8wJ8P6zqXdXGfLCBIAJaZC6+Nxl6VXiPSoddvCvlAwwglo6uRLnGHCCBrxFZh2AWGAXCci0aRMNMEGO1A7N3GGTk1pIRfmRVTow7ULNT9BDciEIAc2dwPnbsiFFvyK6khe6OwCH2vRjrQAi6IYKs0O3Bc6qakveoxEgTXZS3iw+5SJVsgAnC/46qmA24dOSykLZhrIBhI1Iwur8AagYFZRTAzwMPA2BslGQP0XAI8BZqs+WIDNQ6tEKwIYi8IaYoDowjMMYOlPANgDcwFwCWC6AXgSwtaGsNBMANccGI15JUIdZm6D/T3AfktVmFiEzLTaxOGljLnWAqunr8DmMjbO3bx5DrdiT0Z6LCq0s3EuXAcARK2AQMWNdF9HriIaqShK1VrpPLk2SWPsM63wMrWtvLrJghtzH0mwpZU0prmG6W9obUDAaERR2mGK3Rt9dqAkrjF203w14SdJvEKnGD1aFwz5sF/KFKYr1jcdmB02bbOJnWTv3p+n4IcxLR0JeKHk9Tbep66b7mPuYlqL4An4vnKfHryQJ44BsyJ4lTbYaaC6sStNMKvNzcOofrZTnS9Wql7kdhs3zaJt8pb0rXd1HD15NzoUp55ZqurVss05HfRTVp9cuFtXSw72pI80lUSQu32xtF1pOWU1a2qT/eOsUKgKYlCGLH6TQMWIWtH1xFhYkpITP7wbUemmUeVC1lw/4zzRzX15QwzgPMSwDwhhtDLzNN1p4dFsbzpD1UmfJJEQ8rEHTbrJWzn3fYmLaVKmMRI3Vj9Inr0b46Cu60b1/ZjXDe60ZF2ATC0Sj0vMvcwhFDjR00Z4ZwTRQrsmCMM+gNraUqMFYQfxN4dNnxGYggC3TWf9n3N+8MkM3r89rPrvZ5YKzu98RwmBF11DWhde/P1h13NJCraSyCeDop9nIEhywI2cgJnOz4dlSJ03e+8t2kC4Zf15JAdw2N5vzmdg/3Lc3zsOzVoIX4KG3tmtzgPERI3jO076+weU59kleqa8nQP+F5ztu9J74fsrOVtVi3JOXv/oQsBX2rz+0fXmIhvvTA/774UPsL//7vwf0X/869nOTpExEgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8aa32a7dc142358b25f9f0d21cbe236f.svg";
export { ForwardRef as ReactComponent };